export default ({ request }) => ({
  // 订单生产成本信息表相关API
  pdCostsOrderListApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/list',
      method: 'post',
      data,
    })
  },
  pdCostsOrderDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/detail',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGenerateApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/generate',
      method: 'post',
      data,
    })
  },
  pdCostsOrderDelApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/del',
      method: 'post',
      data,
    })
  },
  pdCostsOrderSubmitApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/submit',
      method: 'post',
      data,
    })
  },
  pdCostsOrderReviewApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/review',
      method: 'post',
      data,
    })
  },
  pdCostsOrderRejectApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/reject',
      method: 'post',
      data,
    })
  },
  pdCostsOrderSetCostRateApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/setCostRate',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品表相关API
  pdCostsOrderGoodsTreeApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/tree',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/detail',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品包装成本表相关API
  pdCostsOrderGoodsPackingListApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/packing/list',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsPackingDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/packing/detail',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsPackingSaveApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/packing/save',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsPackingDelApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/packing/del',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品其他费用表相关API
  pdCostsOrderGoodsOtherfeesListApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/otherfees/list',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsOtherfeesDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/otherfees/detail',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsOtherfeesSaveApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/otherfees/save',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsOtherfeesDelApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/otherfees/del',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品规格表相关API
  pdCostsOrderGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/detail',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品规格面料用量表相关API
  pdCostsOrderGoodsSpecFabricListApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/fabric/list',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecFabricDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/fabric/detail',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecFabricSaveApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/fabric/save',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecFabricDelApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/fabric/del',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品规格辅料用量表相关API
  pdCostsOrderGoodsSpecMaterialListApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/material/list',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecMaterialDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/material/detail',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecMaterialSaveApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/material/save',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecMaterialDelApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/material/del',
      method: 'post',
      data,
    })
  },
  // 订单生产成本产品规格工序表相关API
  pdCostsOrderGoodsSpecProcessListApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/process/list',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecProcessDetailApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/process/detail',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecProcessUpdateApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/process/update',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecProcessAddApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/process/add',
      method: 'post',
      data,
    })
  },
  pdCostsOrderGoodsSpecProcessDelApi(data = {}) {
    return request({
      url: '/factory/pd/costs/order/goods/spec/process/del',
      method: 'post',
      data,
    })
  },
})
